var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('video',{staticClass:"metodist-video",attrs:{"autoplay":"","playsinline":"","src":_vm.metodistVideo},on:{"ended":_vm.handleVideoEnd}})
}
var staticRenderFns = []

export { render, staticRenderFns }